module.exports = __webpack_public_path__ + "img/slider-arrow-right-bg-white.3dc31276.svg";